import { fetchAppSettings } from './api';
import { renderAppSettings } from './render';
import { updateSetting } from './update';

// render the settings popup
document.addEventListener('DOMContentLoaded', () => {
    const appSettingLink = document.getElementById('app_setting_link');
    console.log('appSettingLink')
    console.log(appSettingLink)
    if (appSettingLink) {
        appSettingLink.addEventListener('click', async () => {
            renderLoadingOverlay();
            const settings = await fetchAppSettings();
            const content = renderAppSettings(settings);
            createModal(content, 'App Settings'); // Assumes `createModal` is globally accessible
            removeLoadingOverlay();
        });
    }
});

// update the settings

document.addEventListener('DOMContentLoaded', () => {
    const appSettingLink = document.getElementById('app_setting_link');

    if (appSettingLink) {
        appSettingLink.addEventListener('click', () => {
            // Wait for modal to be injected and displayed
            document.body.addEventListener('change', async event => {
                const input = event.target;
                if (input.matches('[data-key]')) { // Check if it's a settings input
                    const settingKey = input.dataset.key;
                    let settingValue;

                    if (input.type === 'checkbox') {
                        settingValue = input.checked;
                    } else if (input.type === 'number') {
                        settingValue = parseFloat(input.value);
                    } else {
                        settingValue = input.value; // Default for text, dropdown, etc.
                    }

                    await updateSetting(settingKey, settingValue);
                }
            });
        });
    }
});

